// TODO - Documentar
import { EditModelValueHook, StateModelParameterHook } from '../hooks/ModelParameterHooks'
import * as con from "../../GlobalConstants"
import { CellNumeric, CellPercentage } from '../../templates/tables/Cells'
import {  isSorted } from '../../GlobalFunctions'
import { GenericElement } from '../../templates/FormElement'
import { ClickOutsideAction } from '../../templates/hooks/ClickOutiseAction'
import { FaMinus, FaPlus } from 'react-icons/fa'
import {  RefApplicationParameterHook } from '../hooks/ApplicationParametersHooks'
import { useForwardCurve } from '../hooks/ForwardCalculatorHooks'


function ForwardCurveTable() {

    // Forward Curve
    const [forwardCurveActive, setForwardCurveActive] = StateModelParameterHook(con.CUSTOM_FORWARD_CURVE_ACTIVE)
    const setCustomForwardCurve = EditModelValueHook(con.CUSTOM_FORWARD_CURVE)

    // Market Forward Curve
    const forwardCurve = useForwardCurve()

    // Editing outside Hook (for sorting)
    const tableRef = ClickOutsideAction(() => sortForwardCurve())

    // Determine if mobile
    const isMobile = RefApplicationParameterHook(con.IS_MOBILE)


    const updateForwardCurveDay = (i, newVal) =>
    {

      newVal = parseInt(newVal)

      if(isNaN(newVal))
        newVal=0
      
      const updated = {
          ...forwardCurve,
          [con.DAYS]: [...forwardCurve[con.DAYS]]
      }
      updated[con.DAYS][i] = newVal
      setCustomForwardCurve(updated)
    } 

    const updateForwardCurvePercentage = (i, type, newVal) => {
        const updated = {
            ...forwardCurve,
            [type]: [...forwardCurve[type]]
        }
        updated[type][i] = newVal
        setCustomForwardCurve(updated)
    }

    const sortForwardCurve = () => {
        if (!forwardCurve) return
        if (isSorted(forwardCurve[con.DAYS])) return

        const days = [...forwardCurve[con.DAYS]]
        const buy = [...forwardCurve[con.BUY]]
        const sell = [...forwardCurve[con.SELL]]

        const indices = days.map((_, i) => i).sort((a, b) => days[a] - days[b])

        setCustomForwardCurve({
            [con.DAYS]: indices.map(i => days[i]),
            [con.BUY]: indices.map(i => buy[i]),
            [con.SELL]: indices.map(i => sell[i]),
        })
    }

    // Table Controls
    const addRow = (i) => {
        const days = [...forwardCurve[con.DAYS]]
        const buy = [...forwardCurve[con.BUY]]
        const sell = [...forwardCurve[con.SELL]]

        let newDay, newBuy, newSell
        if (i === days.length - 1) {
            newDay = days[i] * 2
            newBuy = buy[i]
            newSell = sell[i]
        } else {
            newDay = (days[i] + days[i + 1]) / 2
            newBuy = (buy[i] + buy[i + 1]) / 2
            newSell = (sell[i] + sell[i + 1]) / 2
        }

        days.splice(i + 1, 0, newDay)
        buy.splice(i + 1, 0, newBuy)
        sell.splice(i + 1, 0, newSell)

        setCustomForwardCurve({ [con.DAYS]: days, [con.BUY]: buy, [con.SELL]: sell })
    }

    const removeRow = (i) => {
        setCustomForwardCurve({
            [con.DAYS]: forwardCurve[con.DAYS].filter((_, j) => j !== i),
            [con.BUY]: forwardCurve[con.BUY].filter((_, j) => j !== i),
            [con.SELL]: forwardCurve[con.SELL].filter((_, j) => j !== i),
        })
    }

  return (
    <div className="compact" style={{width : "98%"}}>
    <h4>{forwardCurveActive ? "Curva Forward Personalizada" : "Curva Forward Lumen"}</h4> 
    {
                !isMobile && (
                    <div className="smallParameterBox">
                        <GenericElement
                            type={con.BOOLEAN}
                            id={con.CUSTOM_FORWARD_CURVE_ACTIVE}
                            value={forwardCurveActive}
                            setValue={setForwardCurveActive}
                            label={'Activar Personalizada'}
                        />
                    </div>
                )
            }
    <div className="contenedor-tabla">

        <div className="flex-tabla">
            <div className="flex-fila header-row">
                <div className="flex-celda ">DIAS</div>
                <div className={`flex-celda`}>COMPRA</div>
                <div className={`flex-celda`}>VENTA</div>
                {forwardCurveActive && !isMobile ? <div className="flex-celda">COMANDOS</div> : null}
                    </div>
        </div>

       <div ref={tableRef} className="flex-tabla"> 
            {

              forwardCurve[con.DAYS].map((d,i) => {
                return(

                <div key={i} className={`flex-fila hoverable-row ${(i % 2 === 0)? "even-row":"uneven-row"}`}>            
                    <div className="flex-celda"><CellNumeric value={d} editing={forwardCurveActive && !isMobile} setValue={(newVal) => updateForwardCurveDay(i,newVal)} heavyEffect={true}/></div>
                    <div className={`flex-celda`}><CellPercentage value={forwardCurve[con.BUY][i]} editing={forwardCurveActive && !isMobile} setValue={(newVal) => updateForwardCurvePercentage(i, con.BUY, newVal)} heavyEffect={true}  decimalScale={2}/></div>
                    <div className={`flex-celda`}><CellPercentage value={forwardCurve[con.SELL][i]} editing={forwardCurveActive && !isMobile} setValue={(newVal) => updateForwardCurvePercentage(i, con.SELL, newVal)} heavyEffect={true}  decimalScale={2}/></div>
                    {forwardCurveActive && !isMobile ?
                    <div className={`flex-celda comandos`}>        
                            <FaPlus style={{cursor: "pointer"}} 
                                                onClick={() => addRow(i)}
                                                title="Agregar Fila"/>
                            <FaMinus className={forwardCurve[con.DAYS].length === 0 ? 'disabled' : ""} style={{cursor: "pointer"}} 
                                                  onClick={() => removeRow(i)}
                                                  title="Eliminar Fila"
                                                  />                                        
                  </div> : null}
                </div>

                )
              })
             }            
        </div>
        
    </div>
</div>
  )
}

export default ForwardCurveTable